import { Button } from "./ui/button";
import { PageLink } from "./PageLink";
import { Home, ArrowLeft } from "lucide-react";

interface NotFoundPageProps {
  onNavigate: (page: string) => void;
}

export function NotFoundPage({ onNavigate }: NotFoundPageProps) {
  return (
    <section className="flex items-center justify-center min-h-[60vh] px-6">
      <div className="text-center max-w-md">
        <p className="font-display text-[60px] font-bold leading-none text-royal-indigo mb-4" aria-hidden="true">404</p>
        <h1 className="text-[32px] lg:text-[44px] font-bold tracking-tight text-dark-indigo mb-3">Page not found</h1>
        <p className="text-soft-black mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex gap-3 justify-center">
          <Button
            variant="outline"
            onClick={() => window.history.back()}
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Go back
          </Button>
          <Button asChild><PageLink page={'turfai'} onNavigate={onNavigate}>
            <Home className="w-4 h-4 mr-2" />
            Home
          </PageLink></Button>
        </div>
      </div>
    </section>
  );
}
